//--------------------------------------------------------
// 1. Developer : Raziya S
// 2. Module/Feature Name : Academic Performance
//--------------------------------------------------------

class TermDifference {

    constructor($scope, $state, $stateParams, $sce, $rootScope,
        authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
        'ngInject';
        
        let self = this;
        $rootScope.title = "Difference in Class Average"
        let curriculumId = $state.params.curriculumId
        let sessionId = $state.params.sessionId
        $scope.loading = true
        $scope.dataExists = false
        //Boolean - To set view for fetch
        $scope.isFilter = true;
        $scope.allAcademic_year = localStorageService.get('allAcademic_year')
        //Object - Holds selection data
        $scope.selectAcademics = {};
        let myUserId = localStorageService.get('user_id')
        let activeAcd = localStorageService.get('academic_year')
        let school_id = localStorageService.get('school_id')
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Difference in Class Average"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getSession()
        }
        $scope.barcodeToHtml = function () {
            let lines = $scope.barcode.bcode.lines
            let barcodeNumber = $scope.barcode.bcode.barcodeNumber
            return $sce.trustAsHtml(lines+barcodeNumber);
        }


        function getSession() {
            $scope.toSearchObj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: activeAcd,
                exam: {
                    $exists: 1
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.sessions = response.result.data.details;
                        $scope.selectAcademics.session = undefined;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.curriculums = [];
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                        $scope.loading = false;
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    $scope.loading = false
                    toastr.error('Network Error. Please try later')
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
        }

        $scope.getCuriculum = (session) => {
            $scope.dataExists = false
            $scope.rc_combinations = []
            $scope.toSearchObj.combination = undefined
            $scope.selectAcademics.session = session;
            $scope.toSearchObj.session = $scope.selectAcademics.session._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.curriculums = response.result.data.details;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
        $scope.getClass = (curriculum) => {
            $scope.dataExists = false
            $scope.selectAcademics.curriculum = curriculum;
            $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
            $scope.rc_combinations = []
            $scope.toSearchObj.combination = undefined
        }
        
        $scope.getReport = (year) => {
            $scope.toSearchObj.academic_year = year
            $scope.rc_combinations = []
            $scope.toSearchObj.combination = undefined
            authService.callAPI("/v0/educore_reports/school/get-reports-for-selection", "POST", {
                args : {
                    school_id : $scope.toSearchObj.school_id,
                    year : $scope.toSearchObj.academic_year,
                    curriculum_id : $scope.toSearchObj.curriculum,
                    session_id : $scope.toSearchObj.session
                }
            }, function (response) {
                try{
                    let result = response.result.data.details
                    $scope.rc_combinations = result
                    _.defer(function () {
                        $scope.$apply();
                    });
                }catch(e){
                    console.log(e)
                }
            })
            
        }
        
        $scope.getReportFromCombination = (combination) => {
            $scope.toSearchObj.combination = combination
            getReport($scope.toSearchObj)
            

        }
        function getReport(toSearchObj){
            $scope.loading = true
            authService.callAPI("/v0/educore_reports/school/classavgdiff", "POST", 
            {
                args :{
                    curriculumId : toSearchObj.curriculum,
                    sessionId : toSearchObj.session,
                    schoolId : localStorageService.get('school_id'),
                    activeYear : toSearchObj.academic_year ? toSearchObj.academic_year.year : localStorageService.get('academic_year'),
                    myUserId : localStorageService.get('user_id'),
                    "pdfFlag":"false",
                    FILE_UPLOAD_URL : CONSTANTS.FILE_UPLOAD_URL,
                    combination : toSearchObj.combination
                }
            }, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        if(!response.error){
                            $scope.dataExists = true
                            let result = response.result.data.details
                            console.log(result)
                            $scope.barcode = result.barcode
                            $scope.classArray = result.classArray
                            $scope.settSubject = result.subjectSett
                            $scope.academicYear = result.academic_year
                            $scope.schoolName = result.schoolName
                            $scope.schoolLogo = CONSTANTS.FILE_UPLOAD_URL + result.schoolLogo
                            // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
                            $scope.reportCardConsoleDetails = result.reportCardConsoleDetails
                            $scope.retval = result.retval
                            $scope.diffTerm = result.diffTerm
                            $scope.diffYear = result.diffYear
                            $scope.sessionName = result.sessionName
                            $scope.curriculumName = result.curriculumName
                            //Added generated by and generated date
                            $scope.generatedBy = result.generatedBy
                            $scope.generatedDate = result.generatedDate
                            $scope.urls = result.pdf_url
                        }
                        $scope.loading = false
                        $scope.$apply()
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                $scope.loading = false
                _.defer(function () {
                    $scope.$apply();
                });
            });
            // Meteor.call('getRcPerCurriculum', curriculumId, sessionId, Session.get('school_id'), false, (error, result) => {
            //     if (result) {
            //         $scope.classArray = result.classArray
            //         $scope.settSubject = result.subjectSett
            //         $scope.academicYear = result.academic_year
            //         $scope.schoolName = result.schoolName
            //         // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
            //         $scope.reportCardConsoleDetails = result.reportCardConsoleDetails
            //         $scope.retval = result.retval
            //         $scope.sessionName = result.sessionName
            //         $scope.curriculumName = result.curriculumName
            //         //Added generated by and generated date
            //         $scope.generatedBy = result.generatedBy
            //         $scope.generatedDate = result.generatedDate
    
            //     }
            //     $scope.loading = false
            //     $scope.$apply()
            // })
        }
        $scope.exportpdf = () => {
            $scope.url = $sce.trustAsResourceUrl($scope.urls)
            $scope.isPdfData = true
        }
        $scope.backToHtml = () => {
            $scope.isPdfData = false
            $scope.loading = false
        }

    }
}
export default TermDifference;


// WEBPACK FOOTER //
// ./src/app/educore_reports/school/controllers/classaveragedifferenceController.js